import { Controller } from "@hotwired/stimulus";

const WIDE_KEY = "chapter-text-wide";

export default class extends Controller {
	static targets = ["button", "label"];
	static values = { wideLabel: String, narrowLabel: String };
	declare readonly buttonTarget: HTMLElement;
	declare readonly hasButtonTarget: boolean;
	declare readonly labelTarget: HTMLElement;
	declare readonly hasLabelTarget: boolean;
	declare readonly wideLabelValue: string;
	declare readonly narrowLabelValue: string;
	wide = false;
	morphHandler = () => this.#load();

	connect() {
		this.#load();
		this.element.addEventListener("turbo:morph-element", this.morphHandler);
	}

	disconnect() {
		this.element.removeEventListener("turbo:morph-element", this.morphHandler);
	}

	toggle() {
		this.wide = !this.wide;
		localStorage.setItem(WIDE_KEY, String(this.wide));
		this.#apply();
	}

	#load() {
		this.wide = localStorage.getItem(WIDE_KEY) === "true";
		this.#apply();
	}

	#apply() {
		this.element.classList.toggle("odo-reading--wide", this.wide);
		if (this.hasButtonTarget) this.buttonTarget.setAttribute("aria-pressed", String(this.wide));
		if (this.hasLabelTarget) this.labelTarget.textContent = this.wide ? this.wideLabelValue : this.narrowLabelValue;
	}
}
